import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa069b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[130px] l:mt-[155px] mb-[104px] px-10" }
const _hoisted_2 = {
  key: 0,
  class: "list"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tabs max-w-[1200px] mx-auto" }
const _hoisted_5 = ["data-id"]
const _hoisted_6 = {
  key: 0,
  class: "list"
}
const _hoisted_7 = {
  key: 1,
  class: "in-develop"
}
const _hoisted_8 = {
  key: 2,
  class: "in-develop"
}

import { ref, onMounted, nextTick, toRefs, onBeforeUnmount, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useGlobalStore } from '@/stores/global';
import SlideItem from '@/components/common/SlideItem.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {

const router = useRouter();

const id = +router.currentRoute.value.params.id;

const globalStore = useGlobalStore();
const { category, isMobile, categoryTitle } = toRefs(globalStore);
const { getCategory } = globalStore;

const selectedTab = ref<number>(0);

const tabs = ['Водные круизы', 'РЖД круизы'];

const widgetDataId = ref(
    'YTo0OntzOjI6IklEIjtzOjQ6IjMxNTMiO3M6NDoiVVNFUiI7czoyMDoiYVc1bWIwQnlkbTB0YzNCaUxuSjEiO3M6NjoiUkFORE9NIjtzOjg6IjI0YmJpMjd2IjtzOjE1OiJJTkZPRkxPVC1BUElLRVkiO3M6NDA6ImJmNWVlNWU0ZmJiNTJhMzIzZTQyOWMxODU0ZmJlZTVhODY4NWY1ZWQiO30='
);

onMounted(async () => {
    if (id === 7) {
        await nextTick();
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = `
        (function(d,w){
            var h=d.getElementsByTagName("script")[0];
            s=d.createElement("script");
            s.src="https://bitrix.infoflot.com/local/templates/infoflot/frontend/js/infoflotIframe.js";
            s.async=true;
            s.onload=function(){
            w.createInfoflotWidget("https://bitrix.infoflot.com/rest/api/search.filter/",{
                key: "${widgetDataId.value}",
                referer: encodeURIComponent(location.href)
            });
            };
            h.parentNode.insertBefore(s,h);
        })(document,window);
        `;
        document.body.appendChild(script);
    }

    await getCategory(id as number);
});

onBeforeUnmount(() => {
    category.value = undefined;
    categoryTitle.value = undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: _unref(categoryTitle) ?? 'Назад'
    }, null, 8, ["text"]),
    (_unref(category)?.data.length && id !== 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(category).data, (tour) => {
            return (_openBlock(), _createBlock(SlideItem, {
              id: tour.id,
              key: tour.id,
              title: tour.attributes.title,
              text: tour.attributes.subtitle,
              url: tour.attributes.cover.data?.attributes.url,
              onClick: ($event: any) => (
                    _unref(router).push({
                        name: 'tour',
                        params: { id: tour.id },
                    })
                )
            }, null, 8, ["id", "title", "text", "url", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (id === 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab, idx) => {
              return _createVNode(BaseTypography, {
                key: idx,
                text: tab,
                type: "subtitle3",
                class: _normalizeClass(["cursor-pointer", { active: selectedTab.value === idx }]),
                onClick: ($event: any) => (selectedTab.value = idx)
              }, null, 8, ["text", "onClick", "class"])
            }), 64))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "infoflotWidget",
              "data-id": widgetDataId.value,
              "data-index": 1
            }, null, 8, _hoisted_5)
          ], 512), [
            [_vShow, selectedTab.value === 0]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            (_unref(category)?.data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(category).data, (tour) => {
                    return (_openBlock(), _createBlock(SlideItem, {
                      id: tour.id,
                      key: tour.id,
                      title: tour.attributes.title,
                      text: tour.attributes.subtitle,
                      url: tour.attributes.cover.data?.attributes.url,
                      onClick: ($event: any) => (
                            _unref(router).push({
                                name: 'tour',
                                params: { id: tour.id },
                            })
                        )
                    }, null, 8, ["id", "title", "text", "url", "onClick"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(BaseTypography, {
                    text: "Туры отсутствуют",
                    type: _unref(isMobile) ? 'subtitle2-m' : 'subtitle2'
                  }, null, 8, ["type"])
                ]))
          ], 512), [
            [_vShow, selectedTab.value === 1]
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(category)?.data.length && id !== 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(BaseTypography, {
            text: "Страница в разработке",
            type: _unref(isMobile) ? 'subtitle2-m' : 'subtitle2'
          }, null, 8, ["type"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})